import CaseDescription from './CaseDescription'

export default CaseDescription
